// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isCampaignsGlobalFrequencyCapsResults = arrayOf(
  objectOf({
    type: string,
    messages: number,
    seconds: number,
    tag_name: string,
    tag_id: string,
    category_name: string,
    category_id: string,
  })
);
